const DICTIONARIES = {
  en: {
    cancel: 'Cancel',
    cc_optional: 'CC (Optional)',
    download_toast: 'Payment Statement(s) successfully downloaded!',
    email: 'Email',
    failed_broadcast: 'Payment Statement failed to share. Please try again',
    failed_partial: `Payment Statement failed to share to
    {{count}} phone number(s)
    {{phoneNumber}}.`,
    full_name: 'Full Name',
    incorrect_email_format: 'Please input email in format: example@email.com',
    incorrect_phone_number_format: 'Phone number must begin with 62',
    no_hp: 'No. HP',
    payment_statement_menu: 'Payment Statement',
    phone_number: 'Phone Number',
    share: 'Share',
    subject: 'Subject',
    success_broadcast: 'Payment Statement successfully shared!',
    to: 'To',
    transporter_details: 'Transporter Details',
    whatsapp: 'Whatsapp',
  },
};

export default DICTIONARIES;
